import React, { useEffect } from "react";
import { Dropdown } from "primereact/dropdown";
import * as Fa from "react-icons/fa";
import { Checkbox } from "primereact/checkbox";
import { RadioButton } from "primereact/radiobutton";
import { useState } from "react";
// import { Calendar } from "primereact/calendar";
import Axios from "../../../api/Axios";
// import storage from "../../../Services/Storage";
import { toast } from "react-toastify";
import { downloadExcel } from "../../../Services/GlobalFunc/downloadExcel";
import { GetDateFormat } from "../../../Services/GlobalFunc/DateFormat";
import storage from "../../../Services/Storage";
// import { format } from "date-fns";
const typecategories = [
    { name: "Ltr", key: "L" },
    { name: "Product Value", key: "PV" },
];
const compcategories = [
    { name: "Distributor", key: "DI" },
    { name: "Geography", key: "GE" },
    { name: "Customer", key: "CUS" },
    { name: "Product", key: "PR" },
];
const distcategories = [
    { name: "Sales Executive", key: "SE" },
    //   { name: "Distributor", key: "DIS" },
];
const geographycategories = [
    { name: "State", key: "State" },
    { name: "District", key: "District" },
    { name: "Town", key: "Town" },
];
const customercategories = [
    { name: "Market", key: "Market" },
    { name: "Sector", key: "Sector" },
    { name: "Sub Sector", key: "SubSector" },
    { name: "Sub Sector Detail", key: "SubSectorDetail" },
    { name: "Customer", key: "Customer" },
];
const productcategories = [
    { name: "Product", key: "Product" },
    { name: "Product Variant", key: "ProductVariant" },
];
const downloadFormat = [{ name: "Horizontal", key: "H" }];
// const freecategory = [
//     { name: "Include Free", key: "IF" },
//     { name: "Show Only Free", key: "SF" },
// ];

const auth = storage.getLocal("user");

const downloadfiletypes = [
    { name: "xlsx", key: "xlsx" },
    { name: "csv", key: "csv" },
];

const SalesComparison = () => {
    const [selectedTypesCategories, setSelectedTypesCategories] = useState([
        typecategories[0],
    ]);
    const [selectedGeogCateg, setSelectedGeogCateg] = useState([]);
    const [selectedcompCateg, setSelectedcompCateg] = useState([]);
    const [selectedDistCateg, setSelectedDistCateg] = useState([]);
    const [selectedcustCateg, setSelectedcustCateg] = useState([]);
    const [selectedprodCateg, setSelectedprodCateg] = useState([]);
    const [downloadformatCategory, setDownloadformatCategory] = useState(
        downloadFormat[0]
    );
    // const [freecategories, setFreecategories] = useState(freecategory[0]);
    const [selectedfiletype, setSelectedfiletype] = useState(
        downloadfiletypes[0]
    );

    const [selectedCompareKey, setSelectedCompareKey] = useState(null);

    const [loadingExcel, setLoadingExcel] = useState(false);
    const [months, setMonths] = useState([]);

    const [selectedCompToMonth, setSelectedCompToMonth] = useState([]);
    const [selectedCompFromMonth, setSelectedCompFromMonth] = useState([]);
    const [selectedFromMonth, setSelectedFromMonth] = useState([]);
    const [selectedToMonth, setSelectedToMonth] = useState([]);
    // const onGeogCategoryChange = (e) => {
    //     let _selectedCategories = [...selectedGeogCateg];

    //     if (e.checked) _selectedCategories.push(e.value);
    //     else
    //         _selectedCategories = _selectedCategories.filter(
    //             (category) => category.key !== e.value.key
    //         );

    //     setSelectedGeogCateg(_selectedCategories);
    // };
    // const onCustCategoryChange = (e) => {
    //     let _selectedCategories = [...selectedcustCateg];

    //     if (e.checked) _selectedCategories.push(e.value);
    //     else
    //         _selectedCategories = _selectedCategories.filter(
    //             (category) => category.key !== e.value.key
    //         );

    //     setSelectedcustCateg(_selectedCategories);
    // };
    // const onProdCategoryChange = (e) => {
    //     let _selectedCategories = [...selectedprodCateg];

    //     if (e.checked) _selectedCategories.push(e.value);
    //     else
    //         _selectedCategories = _selectedCategories.filter(
    //             (category) => category.key !== e.value.key
    //         );

    //     setSelectedprodCateg(_selectedCategories);
    // };
    const onSKUCategoryChange = (e) => {
        let _selectedCategories = [...selectedTypesCategories];

        if (e.checked) _selectedCategories.push(e.value);
        else
            _selectedCategories = _selectedCategories.filter(
                (category) => category.key !== e.value.key
            );

        setSelectedTypesCategories(_selectedCategories);
    };

    useEffect(() => {
        let dropdownurl = "SalesReport/GetdropDownValues?";
        const onpageLoad = async () => {
            try {
                const dropdownApi = `${dropdownurl}type=STK_MON_YR`;
                let PopulateDropdownRes = await Axios.get(dropdownApi);
                const currYear = new Date().getFullYear().toString();
                const result = PopulateDropdownRes?.data?.find(
                    (val) => val.OBJ_DESC === `Jan-${currYear}`
                );
                setMonths(PopulateDropdownRes.data);
                setSelectedCompFromMonth(result);
                setSelectedFromMonth(result);
                setSelectedCompToMonth(PopulateDropdownRes.data[0]);
                setSelectedToMonth(PopulateDropdownRes.data[0]);
            } catch (error) {
                console.log(error);
            }
        };
        onpageLoad();
    }, []);


    const handleExportdata = async () => {
        if (selectedcompCateg.length == 0) {
            toast.warning("Please select a Compare Type", {
                position: toast.POSITION.TOP_CENTER,
                pauseOnFocusLoss: false,
                closeButton: false,
                autoClose: 2000,
            });
            return;
        }
        if (
            (selectedcompCateg?.key == "DI" && selectedDistCateg.length == 0) ||
      (selectedcompCateg?.key == "GE" && selectedGeogCateg.length == 0) ||
      (selectedcompCateg?.key == "CUS" && selectedcustCateg.length == 0) ||
      (selectedcompCateg?.key == "PR" && selectedprodCateg.length == 0)
        ) {
            let comp="";
            if (selectedCompareKey == "DI") {
                comp = "Distributor";
            } else if (selectedCompareKey == "GE") {
                comp = "Geography";
            } else if (selectedCompareKey == "CUS") {
                comp = "Customer";
            } else if (selectedCompareKey == "PR") {
                comp = "Product";
            }

            let errormsg = `Please select a ${comp} Type to compare `;
            toast.warning(errormsg, {
                position: toast.POSITION.TOP_CENTER,
                pauseOnFocusLoss: false,
                closeButton: false,
                autoClose: 2000,
            });
            return;
        } else {
            let comparedvaue = "";
            if (selectedcompCateg?.key == "DI") {
                comparedvaue = selectedDistCateg.key;
            } else if (
                selectedcompCateg?.key == "GE"
            ) {
                comparedvaue = selectedGeogCateg.key;
            } else if (
                selectedcompCateg?.key == "CUS"
            ) {
                comparedvaue = selectedcustCateg.key;
            } else if (
                selectedcompCateg?.key == "PR"
            ) {
                comparedvaue = selectedprodCateg.key;
            }
            try {
                setLoadingExcel(true);
                let basesalesURL = "SalesReport/SalesComparisonReports?";
                let salesrptURL = `${basesalesURL}CompId=${
                    auth.CompId
                }&compare=${selectedCompareKey}&comparedValue=${comparedvaue}&basefromDate=${
                    selectedFromMonth.OBJ_CODE
                }&basetoDate=${selectedToMonth.OBJ_CODE}&compfromDate=${
                    selectedCompFromMonth.OBJ_CODE
                }&comptoDate=${selectedCompToMonth.OBJ_CODE}&chkLtr=${
                    selectedTypesCategories.key == "L" ? "Y" : "N"
                }&chkProdValue=${
                    selectedTypesCategories.key == "PV" ? "Y" : "N"
                }&UserId=${auth.UserId}`;
                let dataresponse = await Axios.get(salesrptURL);
                if (dataresponse?.data?.Data?.length>=0) {
                    if (selectedfiletype.key == "xlsx") {
                        downloadExcel(
                            dataresponse?.data?.Data,
                            `SalesComparison${GetDateFormat()}.xlsx`
                        );
                    } else {
                        downloadExcel(
                            dataresponse?.data?.Data,
                            `SalesComparison${GetDateFormat()}.csv`
                        );
                    }
                } else if (dataresponse.data.Status == "warning") {
                    toast.warning(`${dataresponse.data.Message}`, {
                        position: toast.POSITION.TOP_CENTER,
                        pauseOnFocusLoss: false,
                        closeButton: false,
                        autoClose: 2000,
                    });
                }
            } catch (error) {
                console.log(error);
            } finally {
                setLoadingExcel(false);
            }
        }
    };

    const onCompareCategoryChange = (e) => {
        const selectedKey = e.value.key;
        setSelectedcompCateg(e.value);
        if (selectedCompareKey === selectedKey) {
            setSelectedCompareKey(null);
            clearAllSelections();
        } else {
            setSelectedCompareKey(selectedKey);
            clearAllSelections();
        }
    };

    const clearAllSelections = () => {
        setSelectedDistCateg([]);
        setSelectedGeogCateg([]);
        setSelectedcustCateg([]);
        setSelectedprodCateg([]);
    };

    const isSectionDisabled = (sectionKey) => {
        return selectedCompareKey !== sectionKey;
    };

    // const onDistCategoryChange = (e) => {
    //     let _selectedCategories = [...selectedDistCateg];

    //     if (e.checked) _selectedCategories.push(e.value);
    //     else
    //         _selectedCategories = _selectedCategories.filter(
    //             (category) => category.key !== e.value.key
    //         );

    //     setSelectedDistCateg(_selectedCategories);
    // };

    return (
        <>
            <div className="col-12 pt-0 pb-4">
                <div className="row">
                    <div className="col-lg-6 col-md-6 col-sm-12">
                        <h3 className="py-2">Sales Comparison Report</h3>
                    </div>
                    <div className="col-lg-6 col-md-6 col-sm-12">
                        <div className="text-end">
                            <div className="display-b me-3">
                                <Dropdown
                                    value={selectedfiletype}
                                    onChange={(e) => setSelectedfiletype(e.value)}
                                    options={downloadfiletypes}
                                    optionLabel="name"
                                    placeholder="File Type"
                                />
                            </div>
                            <button
                                type="button"
                                className="btn btn-primary"
                                onClick={handleExportdata}
                                disabled={loadingExcel}
                            >
                                {loadingExcel ? "Loading..." : "Export"}{" "}
                                {loadingExcel ? (
                                    <span
                                        className="spinner-border spinner-border-sm"
                                        role="status"
                                        aria-hidden="true"
                                    ></span>
                                ) : (
                                    <Fa.FaFileExport className="ms-2" />
                                )}
                            </button>
                        </div>
                    </div>
                </div>
                <section className="sales-box">
                    <form>
                        <div className="row">
                            <div className="col-lg-3 col-md-3 col-sm-12 mb-3">
                                <h6>Base Period</h6>
                                <label className="form-label  me-2">From</label>
                                <Dropdown
                                    value={selectedFromMonth}
                                    onChange={(e) => setSelectedFromMonth(e.value)}
                                    options={months}
                                    optionLabel="OBJ_DESC"
                                />
                            </div>
                            <div className="col-lg-3 col-md-3 col-sm-12 mb-3 pt-1">
                                <label className="form-label me-2 mt-4">To</label>
                                <Dropdown
                                    value={selectedToMonth}
                                    onChange={(e) => setSelectedToMonth(e.value)}
                                    options={months}
                                    optionLabel="OBJ_DESC"
                                />
                            </div>
                            <div className="col-lg-3 col-md-3 col-sm-12 mb-3">
                                <h6>Comparison Period</h6>
                                <label className="form-label  me-2">From</label>
                                <Dropdown
                                    value={selectedCompFromMonth}
                                    onChange={(e) => setSelectedCompFromMonth(e.value)}
                                    options={months}
                                    optionLabel="OBJ_DESC"
                                />
                            </div>
                            <div className="col-lg-3 col-md-3 col-sm-12 mb-3 pt-1">
                                <label className="form-label me-2 mt-4">To</label>
                                <Dropdown
                                    value={selectedCompToMonth}
                                    onChange={(e) => setSelectedCompToMonth(e.value)}
                                    options={months}
                                    optionLabel="OBJ_DESC"
                                />
                            </div>

                            <div className="col-lg-3 col-md-6 col-sm-12">
                                <label className="form-label mb-2">Download Format</label>
                                <div className="flex d-flex flex-wrap gap-2">
                                    {downloadFormat.map((category) => {
                                        return (
                                            <div
                                                key={category.key}
                                                className="flex align-items-center"
                                            >
                                                <RadioButton
                                                    inputId={category.key}
                                                    name="category"
                                                    value={category}
                                                    onChange={(e) => setDownloadformatCategory(e.value)}
                                                    checked={downloadformatCategory.key === category.key}
                                                />
                                                <label htmlFor={category.key} className="ms-2">
                                                    {category.name}
                                                </label>
                                            </div>
                                        );
                                    })}
                                </div>
                            </div>

                            <div className="col-lg-5 col-md-6 col-sm-12">
                                <div className="flex d-flex flex-wrap pt-4">
                                    {typecategories?.map((category) => {
                                        return (
                                            <div
                                                key={category.key}
                                                className="flex align-items-center mx-2"
                                            >
                                                <Checkbox
                                                    inputId={category.key}
                                                    name="category"
                                                    value={category}
                                                    onChange={onSKUCategoryChange}
                                                    checked={selectedTypesCategories.some(
                                                        (item) => item.key === category.key
                                                    )}
                                                />
                                                <label htmlFor={category.key} className="ms-1">
                                                    {category.name}
                                                </label>
                                            </div>
                                        );
                                    })}
                                </div>
                            </div>
                        </div>
                    </form>
                </section>
                <section className="GreyCheckBoxPanel">
                    <div className="col-lg-12 col-md-12 col-sm-12 mt-2">
                        <div className="rep-panel">
                            <h4>
                                <Fa.FaColumns className="iconP" /> Compair
                            </h4>
                            <div className="CheckBoxPanel pt-1">
                                <div className="row">
                                    {compcategories?.map((category) => {
                                        return (
                                            <div
                                                key={category.key}
                                                className="col-lg-4 col-md-12 col-sm-12 mb-2"
                                            >
                                                <RadioButton
                                                    inputId={category.key}
                                                    name="category"
                                                    value={category}
                                                    onChange={onCompareCategoryChange}
                                                    checked={selectedCompareKey === category.key} // Only one can be checked at a time
                                                />
                                                <label htmlFor={category.key} className="ms-2">
                                                    {category.name}
                                                </label>
                                            </div>
                                        );
                                    })}
                                </div>
                            </div>
                        </div>
                        <div className="rep-panel">
                            <h4>
                                <Fa.FaCubes className="iconP" /> Distributor
                            </h4>
                            {distcategories?.map((category) => {
                                return (
                                    <div
                                        key={category.key}
                                        className="col-lg-4 col-md-12 col-sm-12 mb-2"
                                    >
                                        <RadioButton
                                            inputId={category.key}
                                            name="category"
                                            value={category}
                                            onChange={(e) => setSelectedDistCateg(e.value)}
                                            checked={selectedDistCateg.key === category.key}
                                            disabled={isSectionDisabled("DI")}
                                        />
                                        <label htmlFor={category.key} className="ms-2">
                                            {category.name}
                                        </label>
                                    </div>
                                );
                            })}
                        </div>
                        <div className="rep-panel">
                            <h4>
                                <Fa.FaGlobe className="iconP" /> Geography
                            </h4>
                            <div className="CheckBoxPanel pt-1">
                                <div className="row">
                                    {geographycategories?.map((category) => {
                                        return (
                                            <div
                                                key={category.key}
                                                className="col-lg-4 col-md-12 col-sm-12 mb-2"
                                            >
                                                <RadioButton
                                                    inputId={category.key}
                                                    name="category"
                                                    value={category}
                                                    onChange={(e) => setSelectedGeogCateg(e.value)}
                                                    checked={selectedGeogCateg.key === category.key}
                                                    //   onChange={onGeogCategoryChange}
                                                    //   checked={selectedGeogCateg.some(
                                                    //     (item) => item.key === category.key
                                                    //   )}
                                                    disabled={isSectionDisabled("GE")} // Disable unless "Geography" is selected
                                                />
                                                <label htmlFor={category.key} className="ms-2">
                                                    {category.name}
                                                </label>
                                            </div>
                                        );
                                    })}
                                </div>
                            </div>
                        </div>
                        <div className="rep-panel">
                            <h4>
                                <Fa.FaUser className="iconP" /> Customer
                            </h4>
                            <div className="CheckBoxPanel pt-1">
                                <div className="row">
                                    {customercategories?.map((category) => {
                                        return (
                                            <div
                                                key={category.key}
                                                className="col-lg-4 col-md-12 col-sm-12 mb-2"
                                            >
                                                <RadioButton
                                                    inputId={category.key}
                                                    name="category"
                                                    value={category}
                                                    onChange={(e) => setSelectedcustCateg(e.value)}
                                                    checked={selectedcustCateg.key === category.key}
                                                    //   onChange={onCustCategoryChange}
                                                    //   checked={selectedcustCateg.some(
                                                    //     (item) => item.key === category.key
                                                    //   )}
                                                    disabled={isSectionDisabled("CUS")} // Disable unless "Customer" is selected
                                                />
                                                <label htmlFor={category.key} className="ms-2">
                                                    {category.name}
                                                </label>
                                            </div>
                                        );
                                    })}
                                </div>
                            </div>
                        </div>
                        <div className="rep-panel">
                            <h4>
                                <Fa.FaCube className="iconP" /> Product
                            </h4>
                            <div className="CheckBoxPanel pt-1">
                                <div className="row">
                                    {productcategories?.map((category) => {
                                        return (
                                            <div
                                                key={category.key}
                                                className="col-lg-4 col-md-12 col-sm-12 mb-2"
                                            >
                                                <RadioButton
                                                    inputId={category.key}
                                                    name="category"
                                                    value={category}
                                                    onChange={(e) => setSelectedprodCateg(e.value)}
                                                    checked={selectedprodCateg.key === category.key}
                                                    //   onChange={onProdCategoryChange}
                                                    //   checked={selectedprodCateg.some(
                                                    //     (item) => item.key === category.key
                                                    //   )}
                                                    disabled={isSectionDisabled("PR")}
                                                />
                                                <label htmlFor={category.key} className="ms-2">
                                                    {category.name}
                                                </label>
                                            </div>
                                        );
                                    })}
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </>
    );
};

export default SalesComparison;
